<div class="container pt-3">
  <h4 class="primaryFontColor">{{titel}}</h4>
  <p>{{text}}</p>
  <button class="btn scButton float-right ml-3 mb-3 " (click)="dismiss()">Nein</button>
  <button class="btn pcButton float-right mb-3 " (click)="confirm()">Ja</button>
</div>
